import { ScreenState } from "./screen";

export default class RenderableSegmentationMask{
  /**
   * Provides functions to manipulate and render segmentation masks
   * @param {ImageData} mask The segmentation mask output from BlazePose Model
   * @param {number} scaling The amount to rescale the mask before it can be displayed
   */
  constructor(mask, scaling){
    this.mask = mask
    this.scaling = scaling
  }

  recolor_mask(r,g,b,a){
    const data = this.mask.data;
    for (let i = 0; i < data.length; i += 4){
      if (data[i] > 0){
        data[i] = r;//     R
        data[i+1] = g;//   G
        data[i+2] = b;//   B
        data[i+3] *= a;//  A
      }
    }
  }


  /**
   * Draws the mask unto the canvas
   * @param {ScreenState} screenState The ScreenState Object
   */
  render(screenState){
    // Reference: https://stackoverflow.com/q/3448347/18573662
    const tmpCanvas = new OffscreenCanvas(this.mask.width, this.mask.height);
    tmpCanvas.getContext("2d").putImageData(this.mask, 0, 0);
    // screenState.canvasCtx.imageSmoothingEnabled = false;
    screenState.canvasCtx.drawImage(tmpCanvas,0,0, this.mask.width*this.scaling, this.mask.height*this.scaling);
    // screenState.canvasCtx.imageSmoothingEnabled = true;
  }
}
